import React from 'react'

import { formatTimeHHmm } from '@lib/date'

import '@components/CompactTripCard/TripCard/styles.scss'

interface TimeStationProps {
  time: string
  station: string
}

const TimeStation = ({ station, time }: TimeStationProps) => {
  const timeFormatted = formatTimeHHmm(time, true)

  return (
    <div className="time-station-container">
      <div className="trip-time">{timeFormatted}</div>
      <div className="trip-station" data-tag="departure-station">
        {station}
      </div>
    </div>
  )
}

export default TimeStation
